import { render } from "./documents.vue?vue&type=template&id=6a0b68b9"
import script from "./documents.vue?vue&type=script&lang=ts"
export * from "./documents.vue?vue&type=script&lang=ts"
script.render = render

export default script